import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithInterceptor } from 'src/utils/baseQuery';
import {NotificationInterface} from 'src/services/notification/notificationSlice'


export const NotificationApi = createApi({
  reducerPath: 'NotificationApi',
  baseQuery: baseQueryWithInterceptor,
  tagTypes: ['Notification'],
  endpoints: (builder) => ({
    getNotification: builder.query<NotificationInterface, string>({
      query: (id) => ({
        headers: {
          'Content-type': 'application/json',
        },
        url: `organization/${id}`,
        method: 'GET',
      }),
    }),
  }),
});

export const { useGetNotificationQuery } = NotificationApi;
